angular.module('impactx.productcomparison').service('productComparison', ['dataGen', '$mdToast','ixaProductComparison', function(dataGen, $mdToast, ixaProductComparison) {

    this.addToComparison = function(productId) {
        var dataObj = {
            id: productId
        };

        var newScope = {};
        dataGen.post(newScope, dataObj, "/product/comparison/add").then(function() {
            ixaProductComparison.updateProductComparisonCount();
            $mdToast.show(
                $mdToast.simple()
                    .textContent(newScope.trns.success)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.addExternalProductToComparison = function(productDTO) {
        var product = angular.extend({}, productDTO);
        if (product.descriptionNonTrusted !== undefined) {
            product.description = product.descriptionNonTrusted;
            delete product.descriptionNonTrusted;
        }
        var dataObj = {
            product: product
        };

        var newScope = {};
        dataGen.postAsForm(newScope, dataObj, "/product/comparison/add/external").then(function() {
            ixaProductComparison.updateProductComparisonCount();
            $mdToast.show(
                $mdToast.simple()
                    .textContent(newScope.trns.success)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    return {
        addToComparison: this.addToComparison,
        addExternalProductToComparison: this.addExternalProductToComparison
    }
}
]);